import { render, staticRenderFns } from "./BuySettings.vue?vue&type=template&id=28a9732e&"
import script from "./BuySettings.vue?vue&type=script&lang=js&"
export * from "./BuySettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports